var map = {
	"./domain_ANNEXIN.csv": 79332,
	"./domain_C1.csv": 23442,
	"./domain_C2.csv": 87058,
	"./domain_C2DIS.csv": 81667,
	"./domain_ENTH.csv": 75933,
	"./domain_PH.csv": 33792,
	"./domain_PLA.csv": 92764,
	"./domain_PLD.csv": 59059,
	"./domain_PX.csv": 75444,
	"./domain_START.csv": 27014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60643;